import { getLocalStorage } from '../../../_common/client/local-storage';

const HELPFUL_RATING_STORAGE_KEY = 'cr_helpfulRating_frequency';

export class LocalStorageService {
    private readonly storage = getLocalStorage();

    public isReviewAlreadyVotedOn(productId: string, reviewId: string): boolean {
        const storageValue = this.storage.getItem(`cr_RatedReviews_${productId}`);
        return this.isReviewIdInStorageValue(storageValue, reviewId);
    }
    public markReviewAsVotedOn(productId: string, reviewId: string): void {
        const storageValue = this.storage.getItem(`cr_RatedReviews_${productId}`);
        if (this.isReviewIdInStorageValue(storageValue, reviewId)) return;
        const newStorageValue = storageValue ? `${storageValue},${reviewId}` : reviewId;
        this.storage.setItem(`cr_RatedReviews_${productId}`, newStorageValue);
    }

    public getHelpfulRatingFrequency(): string | null {
        return this.storage.getItem(HELPFUL_RATING_STORAGE_KEY);
    }

    public storeHelpfulRatingFrequency(helpfulRatingFrequency: string): void {
        this.storage.setItem(HELPFUL_RATING_STORAGE_KEY, helpfulRatingFrequency);
    }

    private isReviewIdInStorageValue(storageValue: string | null, reviewId: string): boolean {
        if (!storageValue) return false;
        return storageValue.split(',').includes(reviewId);
    }
}
